import React, { useRef } from 'react';
import { FaImage, FaSpinner, FaTimes, FaUpload } from 'react-icons/fa';
import resolveMediaUrl from '../utils/resolveMediaUrl';
import './CoverImageUploader.css';

const CoverImageUploader = ({ previewUrl, isUploading, onUpload, onRemove }) => {
    const fileInputRef = useRef(null);

    const handleUploadClick = () => {
        fileInputRef.current?.click();
    };

    return (
        <div className="form-group mb-4">
            <label className="form-label d-flex align-items-center">
                <FaImage className="me-2" /> Cover Image
            </label>

            {previewUrl ? (
                <div className="cover-image-preview-container">
                    <div className="position-relative d-inline-block">
                        <img
                            src={resolveMediaUrl(previewUrl)}
                            alt="Cover preview"
                            className="img-thumbnail"
                            style={{ maxWidth: '300px', maxHeight: '200px', objectFit: 'cover' }}
                        />
                        <button
                            type="button"
                            onClick={onRemove}
                            className="btn btn-danger btn-sm position-absolute top-0 end-0 m-2"
                            style={{ opacity: 0.9 }}
                        >
                            <FaTimes /> Remove
                        </button>
                    </div>
                </div>
            ) : (
                <div className="cover-image-upload">
                    <input
                        ref={fileInputRef}
                        id="cover-image"
                        type="file"
                        accept="image/*"
                        onChange={(event) => {
                            const [file] = event.target.files || [];
                            if (file) {
                                onUpload(file);
                            }
                        }}
                        style={{ display: 'none' }}
                        disabled={isUploading}
                    />
                    <div 
                        className="cover-upload-zone" 
                        onClick={handleUploadClick}
                        role="button"
                        tabIndex={0}
                        onKeyPress={(e) => e.key === 'Enter' && handleUploadClick()}
                    >
                        <FaUpload className="upload-icon" />
                        <p className="upload-text">Click to upload cover image</p>
                        <p className="upload-hint">Max 2MB · JPG, PNG, WEBP</p>
                    </div>
                    {isUploading && (
                        <div className="mt-2 text-primary">
                            <FaSpinner className="spinner me-2" />
                            Uploading and compressing image...
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default CoverImageUploader;
